// extracted by css-extract-rspack-plugin
export default {"readyToImportFolder":"M7X9woM9TqE_tj6i"};